import { FinancialConnection } from "@common/types/financialConnection";
import { IntegrationConnection } from "@common/types/integrationConnection";
import { useUser } from "./useUser";

export function isConnectionOwner(
    connection: FinancialConnection | IntegrationConnection,
    userId: number,
) {
    const connectionUserId =
        "userId" in connection ? connection.userId : connection.createdByUserId;

    return connectionUserId === userId;
}

export function useConnectionOwnership(
    connection: FinancialConnection | IntegrationConnection,
) {
    const user = useUser();

    return isConnectionOwner(connection, user.id);
}
